export const GET_DICTIONARY_COURIERS = Symbol('GET_DICTIONARY_COURIERS');
export const GET_DICTIONARY_COURIERS_REQUEST = Symbol('GET_DICTIONARY_COURIERS_REQUEST');
export const GET_DICTIONARY_COURIERS_SUCCESS = Symbol('GET_DICTIONARY_COURIERS_SUCCESS');
export const GET_DICTIONARY_COURIERS_ERROR = Symbol('GET_DICTIONARY_COURIERS_ERROR');

